import React from 'react';
import styled, { css } from 'styled-components';
import Checkbox from './Checkbox';

export default styled.div`
  position: relative;
`;

export const DropDownButton = styled.button`
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const DropDownItemsList = ({ open, children, ...props }) => {
  if (open === false) {
    return null;
  }

  const List = styled.div`
    color: #888;
    position: absolute;
    box-shadow: rgba(0,0,0,.1) 0 .0625rem .125rem;
    z-index: 99;
    background-color: rgba(255,255,255,.97);
    top: 100%;
    right: 0;
  `;

  return <List {...props}>{children}</List>
};

export const DropDownItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1rem;
  color: #1d1f24;
  //font-size: .825rem;
  border-bottom: .0625rem solid #ccc;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  ${props => props.selected && css`
    font-weight: bold;
  `};
`;

export const DropDownItemCheckbox = props => (
  <Checkbox {...props} />
);

// @todo 2019-09-24 Extract somehow. This is a style repetition of Checkbox
export const DropDownItemCheck = styled.div`
  display: inline-block;
  width: .325rem;
  height: .625rem;
  margin-top: .-.25rem;
  margin-right: .25rem;
  margin-left: .375rem;
  border-bottom: 2px solid #020202;
  border-right: 2px solid #020202;
  transform: rotate(38deg);
`;
